import { Link } from 'react-router-dom';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';

function BreadcrumbComponent({
  title,
  titleLink = null,
  subtitle,
  subtitleLink = null,
  subtitle2,
}) {
  return (
    <div className="flex items-center gap-2">
      <Breadcrumb className="overflow-x-auto whitespace-nowrap w-full">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/">
              <BreadcrumbLink>Asosiy</BreadcrumbLink>
            </Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link
              to={subtitle ? titleLink : null}
              className={
                subtitle
                  ? 'cursor-pointer'
                  : 'cursor-text text-black dark:text-white'
              }
            >
              <BreadcrumbLink>{title}</BreadcrumbLink>
            </Link>
          </BreadcrumbItem>
          {subtitle && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <Link
                  to={subtitle2 ? subtitleLink : null}
                  className={
                    subtitle && !subtitle2
                      ? 'cursor-text text-black dark:text-white'
                      : 'cursor-pointer'
                  }
                >
                  <BreadcrumbLink>{subtitle}</BreadcrumbLink>
                </Link>
              </BreadcrumbItem>
            </>
          )}
          {subtitle2 && (
            <>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink className="text-black dark:text-white">
                  {subtitle2}
                </BreadcrumbLink>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  );
}

export default BreadcrumbComponent;
